import { createSelector } from 'reselect';
import {
    handleRehydrateAction,
    handleRemoveAction,
    handleSubmitAction
} from '../../../core/store/helpers/reducer-helper';
import * as fromTransitionActions from './transition.actions';
import { Transition } from './transition.model';

export interface State {
    ids: Array<string>;
    entities: { [id: string]: Transition };
}

export const initialState: State = {
    ids: [],
    entities: {}
};

// tslint:disable-next-line:only-arrow-functions
export function reducer(state = initialState, action: fromTransitionActions.Actions): State {
    switch (action.type) {
        case fromTransitionActions.SUBMIT: {
            return handleSubmitAction(state, action);
        }
        case fromTransitionActions.REHYDRATE: {
            return handleRehydrateAction(state, action);
        }
        case fromTransitionActions.REMOVE: {
            return handleRemoveAction(state, action);
        }
        default: {
            return state;
        }
    }
}

export const getEntities = (state: State) => state.entities;

export const getIds = (state: State) => state.ids;

export const getAll = createSelector(getEntities, getIds, (entities, ids) => ids.map(id => entities[id]));



// WEBPACK FOOTER //
// ./src/vas/business-objects/transition/transition.reducer.ts